module.exports = __webpack_public_path__ + "img/3-3.b004b015.png";